<table class="crossmatch-table">
  <thead>
    <tr>
      <th>Recipient</th>
      <th>Donor</th>
      <th>{{ type }} Result Date</th>
      <th class="hide-xs">Sample Date</th>
      <th class="hide-xs">Date entered</th>
      <th></th>
    </tr>
  </thead>

  <tbody>
    <tr *ngIf="!crossmatches?.length">
      <td colspan="7" class="no-results">
        <i>No results found that match the current selection criteria</i>
      </td>
    </tr>

    <ng-container *ngFor="let x of crossmatches; trackBy: key">
      <tr [id]="(x.recipient?.id || x.recipientEnis) + '|' + (x.donor?.id || x.donorEnis)"
          (click)="showCrossmatchDetails(x)"
          [class.clickable]="true"
          [class.has-comments]="x.comments"
          [class.selected]="selectedCrossmatch && selectedCrossmatch.id === x.id">
        <td>
          {{ x.recipientEnis }} -
          <ng-container *ngIf="x.recipient; else recipientDeleted">
            {{ x.recipient.firstName }} {{ x.recipient.lastName }}
          </ng-container>
          <ng-template #recipientDeleted>
            <em class="historical-text">(Deleted PM-waitlist recipient)</em>
          </ng-template>
        </td>
        <td>
          {{ x.donorEnis }} -
          <ng-container *ngIf="x.donor; else donorDeleted">
            {{ x.donor.firstName }} {{ x.donor.lastName }}
          </ng-container>
          <ng-template #donorDeleted>
            <em class="historical-text">(participant deleted)</em>
          </ng-template>
        </td>
        <td>{{ x.resultDate | date }}</td>
        <td class="hide-xs">{{ x.sampleDate | date }}</td>
        <td>{{ x.dateCreated | date }}</td>
        <td (click)="$event.stopPropagation()">
          <app-rowmenu [comb]="x" (action)="handleAction($event)"></app-rowmenu>
        </td>
      </tr>

      <!-- Details row -->
      <tr *ngIf="selectedCrossmatch && selectedCrossmatch.id === x.id" class="details-row">
        <td colspan="6" class="details-cell">
          <div class="crossmatch-details">
            <div class="details-header">
              <h4>Crossmatch Details</h4>
              <button type="button" class="close-button" (click)="closeCrossmatchDetails()" title="Close">×</button>
            </div>
            <div class="details-content">
              <div class="detail-item" *ngIf="x.reasonExcluded">
                <strong>Reason Excluded:</strong> {{ x.reasonExcluded }}
              </div>
              <div class="detail-item" *ngIf="x.comments">
                <strong>Comments:</strong>
                <div class="comments-text">{{ x.comments }}</div>
              </div>
              <div class="detail-item" *ngIf="!x.comments">
                <em>No comments available for this crossmatch.</em>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

<div class="rowcount" *ngIf="totalRows">
  <div class="spacer"></div>
  <div *ngIf="crossmatches?.length === totalRows; else filteredCount">Showing all {{ totalRows }} combinations</div>
  <ng-template #filteredCount> Showing {{ crossmatches?.length }} of {{ totalRows }} combinations </ng-template>
</div>
